import { translate } from '@/domains/core/localization/translate';
export const {
  nonDeductibleVat,
  deductibleVatLabel,
  deductibleVatTitle,
  deductibleVatDescription
} = translate({
  "nonDeductibleVat": "Non-deductible VAT",
  "deductibleVatLabel": "VAT 0%",
  "deductibleVatTitle": "Good news!",
  "deductibleVatDescription": "You'll pay the VAT-free price for this product. ManoMano takes care of the rest!"
});